// router/index.js

import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import SignUp from "@/views/SignUp.vue";
import SignIn from "@/views/SignIn.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import MainLayout from "@/layouts/MainLayout.vue"; // Import the layout
import UserDashboard from "@/views/UserDashboard.vue"; // Import views
import UserSettings from "@/views/UserSettings.vue";
import DailyReport from "@/views/DailyReport.vue";
import OperatorDashboard from "@/components/OperatorDashboard.vue";
import UserInfo from "@/components/UserInfo.vue"; //
import ProjectInfo from "@/components/ProjectInfo.vue";
import Reports from "@/components/Reports.vue";
import Statistics from "@/views/Statistics.vue";
import { auth } from "@/firebaseConfig"; // Import auth to get currentUser

const routes = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    // Routes for authenticated users will be nested inside MainLayout
    path: "/",
    component: MainLayout,
    meta: { requiresAuth: true }, // Only accessible when authenticated
    children: [
      {
        path: "userdashboard",
        name: "UserDashboard",
        component: UserDashboard,
      },
      {
        path: "operatordashboard",
        name: "OperatorDashboard",
        component: OperatorDashboard,
      },
      {
        path: "usersettings",
        name: "UserSettings",
        component: UserSettings,
      },
      {
        path: "dailyreport",
        name: "DailyReport",
        component: DailyReport,
      },
      {
        path: "reports",
        name: "Reports",
        component: Reports,
      },
      {
        path: "statistics",
        name: "Statistics",
        component: Statistics,
      },
      {
        path: "/user/:uid",
        name: "UserInfo",
        component: UserInfo,
        meta: { requiresAuth: true }, // Add any necessary meta properties
      },
      {
        path: "/project/:projectId",
        name: "ProjectInfo",
        component: ProjectInfo,
        meta: { requiresAuth: true }, // Add any necessary meta properties
      },
    ],
  },
];
 
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const activeProject = store.getters.getActiveProject;
  const isLoggingOut = store.state.isLoggingOut;

  // 1. Protect authenticated routes
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated || isLoggingOut) {
      console.warn("[Router Guard] Blocked access (unauthenticated or logging out)");
      return next("/");
    }
  }
  // Only proceed if the user is authenticated
  if (
  auth.currentUser &&
  store.state.user && // make sure Vuex user is also set
  !store.state.isLoggingOut //  ignore during logout
){
    // Fetch latest user data after ending the current project
    const userId = auth.currentUser.uid;
    if (userId) {
      //  store.dispatch("startUserListener", userId);
    } else {
      console.error("[Router Guard] User ID not available for fetching data.");
    }
  }
  next();
});

export default router;
